/* ADD FILE */
/* UNTAPPED - COLLAPSABLE VARIANT DESCRIPTIONS */
/* 
THE HTML THIS IS INTERACTING WITH IS IN THE LIQUID HTML BLOCK INSIDE
GROUP PRODUCT IN PRODUCT PAGE.
KALLES IS RESPONSIBLE FOR SETTING THE HIDDEN FLAG NOTHING IN OUR CODE MANAGES THIS.
PLEASE SEE: https://support.the4.co/articles/kalles-5-how-to-display-custom-content-for-each-variant-using-metafields#step-3-display-the-metafield-content-in-your-theme
*/

var toggleExtended = false;

function updateToggles(variantDescriptions) {
    toggleExtended = !toggleExtended;

    variantDescriptions.forEach(description => {
        const content = description.querySelector(".metafield-rich_text_field");
        const toggle = description.querySelector(".read-more-toggle");
        content.classList.toggle("collapsed");
        content.classList.toggle("expanded");
        if (toggleExtended) {
            toggle.textContent = "Show less...";
        }
        else {
            toggle.textContent = "Read more...";
        }  
    })
}

document.addEventListener('DOMContentLoaded', function() {
    const descriptionContainer = document.querySelector('hdt-variant-toogle-info');

    if (!descriptionContainer) return;

    const variantDescriptions = descriptionContainer.childNodes;

    variantDescriptions.forEach(description => {
        const content = description.querySelector(".metafield-rich_text_field");
        if (!content) return;

        // Temporarily get height of item if visible
        const wasHidden = description.hidden;
        description.hidden = false;
        const scrollHeight = content.scrollHeight;
        description.hidden = wasHidden;

        const toggle = description.querySelector(".read-more-toggle");

        if (toggleExtended) {
            content.classList.add("expanded");
            toggle.textContent = "Show less...";
        }
        else {
            content.classList.add("collapsed");
            toggle.textContent = "Read more..."
        }

        const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
        const maxHeight = lineHeight * 3;

        // console.log(`${scrollHeight} \n${maxHeight}`);

        if (scrollHeight > maxHeight) {
            toggle.style.display = 'block';

            toggle.addEventListener('click', function() {
                updateToggles(variantDescriptions);
            });
        } else {
            content.classList.remove('collapsed');
        }
    })
})